import React from 'react'
import { POS_TYPES } from '../../../../../../../gateways/breadstack/posConnectionApis'
import { POS_PROVIDER_META } from '../../../../../constants/posProviders'
import { COLORS, SectionLabel } from '../../styleHelpers'

interface Props {
  companies: string[]
  primaryCompanyId: string
}

const logo = POS_PROVIDER_META[POS_TYPES.GREENLINE].logoSrc

// "Connected POS" — one compact row per Greenline company on this store.
export const GreenlineCompanyList: React.FC<Props> = ({
  companies,
  primaryCompanyId,
}) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
    <SectionLabel>Connected POS</SectionLabel>
    {companies.map((company) => (
      <div
        key={company}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          padding: '8px 12px',
          borderRadius: 12,
          border: `1px solid ${COLORS.border}`,
          background: COLORS.surface,
        }}
      >
        <img src={logo} alt="Greenline" width={24} height={24} />
        <span style={{ flex: 1, fontSize: 13, color: COLORS.textPrimary }}>
          <strong style={{ fontWeight: 600 }}>Greenline</strong> · Company{' '}
          {company}
        </span>
        {company === primaryCompanyId && (
          <span
            style={{
              fontSize: 11,
              fontWeight: 600,
              padding: '2px 8px',
              borderRadius: 999,
              color: COLORS.accent,
              background: COLORS.accentSoft,
            }}
          >
            Primary
          </span>
        )}
      </div>
    ))}
  </div>
)
